import React from 'react';

type FillColor = string;
type ClassName = string;

interface IProps {
  fillColor?: FillColor;
  className?: ClassName;
  size?: { width: number; height: number };
}

const BigQuoteIcon = ({
  fillColor = '#8940FA',
  className = '',
  size = { width: 75, height: 49 },
}: IProps): React.ReactElement<React.ReactNode> => (
  <svg
    width={size.width}
    height={size.height}
    viewBox="0 0 75 49"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.17 35.7746C31.17 39.1986 29.8122 42.1503 27.0966 44.6297C24.4991 47.1092 20.839 48.3489 16.1163 48.3489C11.3936 48.3489 7.49733 46.5188 4.42755 42.8587C1.47585 39.0805 0 34.4759 0 29.0448C0 23.4956 1.88909 18.0644 5.66727 12.7514C9.56352 7.43829 14.6995 3.18784 21.0752 0L35.7746 8.1467C26.6834 12.3971 21.1932 17.5331 19.3041 23.5546C22.61 24.1449 25.3846 25.4437 27.6279 27.4508C29.9893 29.458 31.17 32.2326 31.17 35.7746Z"
      fill={fillColor}
      fillOpacity="0.25"
    />
    <path
      d="M70.3953 35.7746C70.3953 39.1986 69.0376 42.1503 66.322 44.6297C63.7245 47.1092 60.0644 48.3489 55.3417 48.3489C50.6189 48.3489 46.7227 46.5188 43.6529 42.8587C40.7012 39.0805 39.2254 34.4759 39.2254 29.0448C39.2254 23.4956 41.1145 18.0644 44.8926 12.7514C48.7889 7.43829 53.9248 3.18784 60.3005 0L75 8.1467C65.9088 12.3971 60.4186 17.5331 58.5295 23.5546C61.8354 24.1449 64.61 25.4437 66.8533 27.4508C69.2147 29.458 70.3953 32.2326 70.3953 35.7746Z"
      fill={fillColor}
      fillOpacity="0.25"
    />
  </svg>
);

export { BigQuoteIcon };
